import { __assign, __extends, __rest } from "tslib";
import { isSupported } from 'clipboard';
import React, { Component } from 'react';
import Clipboard from 'react-clipboard.js';
import { CHECKBOX_TICK_ICON } from '@marvelapp/theme';
import { Button, Icon, PinAll, PinCenter, Position } from '@marvelapp/ui';
import { Element, ScaleAndFade, SlideAndFade } from './styles';
var IDLE = 'IDLE';
var COPY_SUCCESS = 'COPY_SUCCESS';
var COPY_ERROR = 'COPY_ERROR';
var TRANSITION_ICON = 'icon';
function delay(ms, val) {
    if (val === void 0) { val = true; }
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(val); }, ms);
    });
}
var CopyToClipboard = /** @class */ (function (_super) {
    __extends(CopyToClipboard, _super);
    function CopyToClipboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            status: IDLE,
        };
        _this.unmounting = false;
        _this.safeSetState = function (updater) {
            return new Promise(function (resolve) {
                if (!_this.unmounting) {
                    _this.setState(updater, resolve);
                }
            });
        };
        _this.onSuccess = function () {
            _this.safeSetState({
                status: COPY_SUCCESS,
            }).then(_this.resetStatus);
        };
        _this.onError = function () {
            _this.safeSetState({
                status: COPY_ERROR,
            }).then(_this.resetStatus);
        };
        _this.resetStatus = function () {
            return delay(_this.props.timeout).then(function () {
                return _this.safeSetState({
                    status: IDLE,
                });
            });
        };
        _this.getText = function () {
            return _this.props.clipboardText
                ? _this.props.clipboardText
                : _this.props.text;
        };
        return _this;
    }
    CopyToClipboard.prototype.componentWillUnmount = function () {
        this.unmounting = true;
    };
    CopyToClipboard.prototype.render = function () {
        var _a = this.props, btnText = _a.btnText, iconColor = _a.iconColor, iconHeight = _a.iconHeight, iconWidth = _a.iconWidth, onCopy = _a.onCopy, transitionType = _a.transitionType, truncated = _a.truncated, wrapperStyle = _a.wrapperStyle, rest = __rest(_a, ["btnText", "iconColor", "iconHeight", "iconWidth", "onCopy", "transitionType", "truncated", "wrapperStyle"]);
        var status = this.state.status;
        var hasSucceded = status === COPY_SUCCESS;
        var isIcon = transitionType === TRANSITION_ICON;
        return (React.createElement(Clipboard, { component: "div", onClick: onCopy, onError: this.onError, onSuccess: this.onSuccess, "option-text": this.getText, style: wrapperStyle },
            React.createElement(Element, __assign({ minWidth: isIcon ? 20 : 48 }, rest), isIcon ? (React.createElement(ScaleTransition, { btnText: btnText, hasSucceded: hasSucceded, iconColor: iconColor, iconHeight: iconHeight, iconWidth: iconWidth, truncated: truncated })) : (React.createElement(SlideTransition, { btnText: btnText, hasSucceded: hasSucceded, iconColor: iconColor, truncated: truncated })))));
    };
    return CopyToClipboard;
}(Component));
function ScaleTransition(_a) {
    var btnText = _a.btnText, hasSucceded = _a.hasSucceded, iconColor = _a.iconColor, iconHeight = _a.iconHeight, iconWidth = _a.iconWidth, truncated = _a.truncated;
    return (React.createElement(Position, null,
        React.createElement(ScaleAndFade, { "data-testid": "copy-to-clipboard-value", opacity: hasSucceded ? 0 : 1, scale: hasSucceded ? 0 : 1, truncated: truncated }, btnText),
        React.createElement(PinCenter, null,
            React.createElement(ScaleAndFade, { opacity: hasSucceded ? 1 : 0, scale: hasSucceded ? 1 : 0 },
                React.createElement(Icon, { color: iconColor, display: "block", height: iconWidth, paths: CHECKBOX_TICK_ICON, width: iconHeight })))));
}
function SlideTransition(_a) {
    var btnText = _a.btnText, hasSucceded = _a.hasSucceded, truncated = _a.truncated;
    return (React.createElement(Position, null,
        React.createElement(SlideAndFade, { "data-testid": "copy-to-clipboard-value", opacity: hasSucceded ? 0 : 1, translate: hasSucceded ? -5 : 0, truncated: truncated }, btnText),
        React.createElement(PinAll, null,
            React.createElement(SlideAndFade, { opacity: hasSucceded ? 1 : 0, translate: hasSucceded ? 0 : 5 }, "Copied!"))));
}
CopyToClipboard.defaultProps = {
    timeout: 1000,
    as: Button,
    btnText: 'Copy',
    transitionType: 'text',
    iconColor: 'white',
};
export default CopyToClipboard;
export var isCopyToClipboardSupported = isSupported;
